import { useLocation, useParams } from 'react-router-dom'

import { JobInvoicesPanel } from '@/components/jobs/job-invoices-panel'
import { getServiceInstanceIdFromSearch } from '@/lib/service-instance'

export default function JobInvoiceA4PreviewPage() {
  const { jobId } = useParams<{ jobId: string }>()
  const location = useLocation()
  const serviceInstanceId = getServiceInstanceIdFromSearch(location.search)

  if (!jobId) {
    return null
  }

  return (
    <JobInvoicesPanel
      jobId={jobId}
      serviceInstanceId={serviceInstanceId}
      variant="a4-preview"
    />
  )
}
